import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { 
  FaCheckCircle, 
  FaTimesCircle, 
  FaTruck, 
  FaBoxOpen, 
  FaMoneyBillWave,
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaCalendarAlt
} from 'react-icons/fa';
import { FiPackage } from 'react-icons/fi';
import './retailers.css';

const OrderDetailsPageRtl = () => {
  const { orderId } = useParams();
  
  // Mock order data 
  const order = {
    id: orderId,
    status: 'Shipped',
    customer: {
      name: 'Oluwaseun Adeyemi',
      phone: '+234 812 345 6789',
      address: '123 Farm Road, Lagos, Nigeria'
    },
    items: [
      { id: 1, name: 'Premium Rice Seeds (5kg)', quantity: 3, price: '₦12,500', total: '₦37,500' },
      { id: 2, name: 'Organic Fertilizer (10kg)', quantity: 2, price: '₦8,750', total: '₦17,500' },
      { id: 3, name: 'Garden Tools Set', quantity: 1, price: '₦3,500', total: '₦3,500' }
    ],
    paymentMethod: 'Card',
    deliveryMethod: 'Express',
    orderDate: '2025-05-15',
    deliveryDate: '2025-05-18',
    subtotal: '₦58,500',
    shippingFee: '₦2,500',
    total: '₦61,000',
    trackingNumber: 'APW123456789',
    timeline: [
      { status: 'Order Placed', date: '2025-05-15 10:30 AM', completed: true },
      { status: 'Payment Confirmed', date: '2025-05-15 10:45 AM', completed: true },
      { status: 'Processing', date: '2025-05-15 11:30 AM', completed: true },
      { status: 'Shipped', date: '2025-05-16 09:15 AM', completed: true },
      { status: 'In Transit', date: '2025-05-17', completed: false },
      { status: 'Delivered', date: '', completed: false }
    ]
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'Order Placed':
      case 'Payment Confirmed':
      case 'Processing':
        return <FaCheckCircle className="text-green-500" />;
      case 'Shipped':
      case 'In Transit':
        return <FaTruck className="text-blue-500" />;
      case 'Delivered':
        return <FaBoxOpen className="text-purple-500" />;
      case 'Cancelled':
        return <FaTimesCircle className="text-red-500" />;
      default:
        return <FaCheckCircle className="text-gray-500" />;
    }
  };

  return (
    <div className="order-details-container-rtl">
      <div className="order-header-rtl">
        <h1>Order #{order.id}</h1>
        <div className={`order-status-badge-rtl ${order.status.toLowerCase()}-rtl`}>
          {order.status}
        </div>
      </div>

      <div className="order-timeline-rtl">
        <h2>Order Progress</h2>
        <div className="timeline-steps-rtl">
          {order.timeline.map((step, index) => (
            <div 
              key={index} 
              className={`timeline-step-rtl ${step.completed ? 'completed-rtl' : ''}`}
            >
              <div className="timeline-icon-rtl">
                {getStatusIcon(step.status)}
              </div>
              <div className="timeline-content-rtl">
                <h3>{step.status}</h3>
                {step.date && <p>{step.date}</p>}
              </div>
              {index < order.timeline.length - 1 && (
                <div className="timeline-connector-rtl"></div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="order-grid-rtl">
        <div className="order-customer-info-rtl">
          <h2>Customer Information</h2>
          <div className="customer-details-rtl">
            <div className="detail-item-rtl">
              <FaUser className="detail-icon-rtl" />
              <span>{order.customer.name}</span>
            </div>
            <div className="detail-item-rtl">
              <FaPhone className="detail-icon-rtl" />
              <span>{order.customer.phone}</span>
            </div>
            <div className="detail-item-rtl">
              <FaMapMarkerAlt className="detail-icon-rtl" />
              <span>{order.customer.address}</span>
            </div>
          </div>
        </div>

        <div className="order-summary-rtl">
          <h2>Order Summary</h2>
          <div className="summary-details-rtl">
            <div className="detail-item-rtl">
              <FaCalendarAlt className="detail-icon-rtl" />
              <span>Order Date: {order.orderDate}</span>
            </div>
            <div className="detail-item-rtl">
              <FaClock className="detail-icon-rtl" />
              <span>Delivery Date: {order.deliveryDate}</span>
            </div>
            <div className="detail-item-rtl">
              <FiPackage className="detail-icon-rtl" />
              <span>Tracking #: {order.trackingNumber}</span>
            </div>
            <div className="detail-item-rtl">
              <FaMoneyBillWave className="detail-icon-rtl" />
              <span>Payment Method: {order.paymentMethod}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="order-items-rtl">
        <h2>Order Items</h2>
        <table className="items-table-rtl">
          <thead>
            <tr>
              <th>Product</th>
              <th>Quantity</th>
              <th>Unit Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map(item => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.quantity}</td>
                <td>{item.price}</td>
                <td>{item.total}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{order.subtotal}</td>
            </tr>
            <tr>
              <td colSpan="3">Shipping Fee</td>
              <td>{order.shippingFee}</td>
            </tr>
            <tr className="total-row-rtl">
              <td colSpan="3">Total</td>
              <td>{order.total}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="order-actions-rtl">
        <button className="action-btn-rtl print-btn-rtl">Print Invoice</button>
        <Link to="/dashboard/retailer-dashboard/orders" className="action-btn-rtl back-btn-rtl">
          Back to Orders
        </Link>
      </div>
    </div>
  );
};

export default OrderDetailsPageRtl;